module.exports = __webpack_public_path__ + "static/media/appstore.1ef55f9d.png";